export default "__VITE_ASSET__Dg1BIPIx__"